import LiFiClient from '@plug-core/clients/LiFiClient'
import { EarnPosition, EarnVault } from '@plug-core/interfaces/earn'
import { logger } from '@plug-core/logger'
import { Spinner, Text } from '@ui'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { VaultDetails } from './VaultDetails'

interface Props {
  position: EarnPosition
  onClose: () => void
}

export const PositionDetails: FC<Props> = ({ position, onClose }) => {
  const { t } = useTranslation()
  const [vault, setVault] = useState<EarnVault>()
  const [error, setError] = useState(false)

  useEffect(() => {
    new LiFiClient()
      .getVault(position.chainId, position.address)
      .then(setVault)
      .catch((e) => {
        logger.error('Failed to fetch vault details', { originalError: e })
        setError(true)
      })
  }, [position.chainId, position.address])

  if (error) {
    return (
      <div className="flex flex-col items-center py-8">
        <Text variant="body-s" tone="fg-2">
          {t('earn.vaultDetailsError')}
        </Text>
      </div>
    )
  }

  if (!vault) {
    return (
      <div className="flex flex-col items-center py-8 text-fg-2">
        <Spinner size={24} />
      </div>
    )
  }

  return <VaultDetails vault={vault} position={position} onClose={onClose} />
}
